import { createActions, createReducer } from "reduxsauce"
import { Types as BaseTypes } from "modules/portfolio-root/model"

export const { Types, Creators } = createActions({
  setCategory: ["category"],
}, {
  prefix: "ompnt/modules/factor-category-selector",
})

const INITIAL_STATE = { category: "default" }

const handleSetCategory = (state, action) => {
  return { ...state, category: action.category }
}

const handleModelChange = (state) => {
  return { ...state, ...INITIAL_STATE }
}

export default createReducer(INITIAL_STATE, {
  [Types.SET_CATEGORY]: handleSetCategory,
  [BaseTypes.SET_MODEL]: handleModelChange,
})
